import React from 'react';
import SubCategorias from './SubCategorias';
//import firebase from './../Firestore'
import store from '../../store';

class Categorias extends React.Component {

  _isMounted = false;
  _seDesplaza = true;

constructor(props) {
  super(props);
  this.state = {
    cat: this.props.cat,
    seFracciona: true,
    catSeleccionada: this.props.catSeleccionada,
    diseno: "pizza",
    interface: "listado",
    vieneDelCarrito: false
   };


   store.subscribe(() => {
     this.setState({
       interface: store.getState().interface
     })
   });


}



componentDidUpdate(prevProps, prevState) {
if (this._isMounted) {
  if(this.props.cat !== prevProps.cat){
      this.setState({
        cat: this.props.cat,
        catSeleccionada: this.props.cat[0].id,
        seFracciona: this.props.cat[0].seFracciona,
        diseno: this.props.cat[0].diseno
       })
  }
}
}


componentWillUnmount(){
  //console.log("en cat WillUnmount")
  this._isMounted = false;

  //store.unsubscribe(this);
}

componentWillMount(){

   if (this._isMounted) {
     if(this.props.vieneDelCarrito){

         this.setState({
            cat: this.props.cat,
            catSeleccionada: this.props.cat[0].id,
            seFracciona: this.props.cat[0].seFracciona,
            diseno: this.props.cat[0].diseno,
            vieneDelCarrito: this.props.vieneDelCarrito
           })
     }

   }
}


componentDidMount(){
   this._isMounted = true;
   this._seDesplaza = true;
   if (this._isMounted) {
     if(this.props.vieneDelCarrito){

       this.setState({
         cat: this.props.cat,
         catSeleccionada: this.props.cat[2].id,
         seFracciona: this.props.cat[2].seFracciona,
         diseno: this.props.cat[2].diseno
        })
     }
   }
}

onChange(event) {
  //console.log(event.target)
  //return
  this._seDesplaza = false;

  let a = this.state.cat
  let i;
  let seFracciona = false;
  let diseno = ""
  for (i = 0; i < a.length; i++) {
    if(a[i].id === event.target.id) {
      if(a[i].seFracciona === true) seFracciona = true;
      diseno = a[i].diseno;
    }
  }


  this.setState(
    { catSeleccionada: event.target.id,
      seFracciona: seFracciona,
      diseno: diseno}
  );



}

render() {
    //console.log("this.seDesplaza", this._seDesplaza, this._isMounted)
    const classBotonSeleccionado =
          {
          clase: "btn btn-success border border-dark badge badge-pill p-2 mx-2",
          estilo:  {borderWidth: 'thick', borderStyle:'solid'}
          };
    const classBotonNoSeleccionado =
          {
          clase: "btn btn-light border border-warning text-danger badge badge-pill p-2 mx-2",
          estilo: {borderWidth: 'thin', borderStyle:'solid'}
        };

    const ItemsOrdenados = []
    for(let i in this.props.cat){
      //  console.log("categoria", categoria)
      if(this.props.cat[i].id === this.state.catSeleccionada) {

        if(this._seDesplaza){
          ItemsOrdenados.unshift(
            {
             id: this.props.cat[i].id,
             nombre: this.props.cat[i].nombre,
             clase: classBotonSeleccionado.clase,
             estilo: classBotonSeleccionado.estilo
              });
        }else{
          ItemsOrdenados.push(
            {
             id: this.props.cat[i].id,
             nombre: this.props.cat[i].nombre,
             clase: classBotonSeleccionado.clase,
             estilo: classBotonSeleccionado.estilo
           });

        }



    } else {
    ItemsOrdenados.push(
      {
      id: this.props.cat[i].id,
      nombre: this.props.cat[i].nombre,
      clase: classBotonNoSeleccionado.clase,
      estilo: classBotonNoSeleccionado.estilo
      });
  }

  }
    //console.log("ItemsOrdenados", ItemsOrdenados)

    const Items = ItemsOrdenados.map((todo) =>

      <span id={todo.id} onClick={event => this.onChange(event)} key={todo.id} className={todo.clase} >{todo.nombre}</span>

    );


    const divStyle = {
      overflow: 'auto'
    };

    return (
      <div>
          <div className="bg-danger p-2 mb-0 d-flex flex-nowrap justify-content-sm-center" style={divStyle}>

              {Items}

          </div>


          <SubCategorias diseno={this.state.diseno} categoriaId={this.state.catSeleccionada} seFracciona={this.state.seFracciona} uid={this.props.uid} vieneDelCarrito={this.state.vieneDelCarrito}/>



      </div>
    )
  }

}
export default Categorias
